// Utility function to convert VAPID key format
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// Sends the PushSubscription object to your Rails controller (Step 2)
async function saveSubscription(subscription) {
  const url = '/push_subscriptions';

  await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // Get the CSRF token from the meta tag
      'X-CSRF-Token': document.head.querySelector('meta[name="csrf-token"]').content
    },
    body: JSON.stringify({
      subscription: subscription,
    })
  });
}

async function subscribeUser() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('Push notifications not supported.');
    return;
  }

  try {
    const VAPID_PUBLIC_KEY = document.head.querySelector("meta[name='webpush-key']").content;
    const applicationServerKey = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);

    // Register the Service Worker (must be at the root: /service-worker.js)
    const registration = await navigator.serviceWorker.register('/service-worker.js');

    let subscription = await registration.pushManager.getSubscription();

    // Subscribe if not already subscribed
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
      });
      console.log('User successfully subscribed.');
    }

    // Save/Update the subscription on the Rails server
    await saveSubscription(subscription);

  } catch (err) {
    console.error('Failed to subscribe or save subscription:', err);
  }
}

// Run the subscription logic on page load
document.addEventListener('DOMContentLoaded', subscribeUser);


// // Run the unsubscription logic
//   navigator.serviceWorker.ready.then(registration => {
//   registration.pushManager.getSubscription().then(subscription => {
//     if (subscription) {
//       subscription.unsubscribe().then(successful => {
//         console.log('Unsubscribed:', successful);
//       });
//     }
//   });
// });
